export function resolve(obj: unknown, path: string | string[], separator = '.') {
  return (Array.isArray(path) ? path : path.split(separator)).reduce((prev, curr) => prev && prev[curr], obj);
}
